import { CircleCompletedSvg } from "@/components/svg"
import { Circle1Active } from "@/components/svg/circle-1-active"
import { Circle2 } from "@/components/svg/circle-2"
import { Circle2Active } from "@/components/svg/circle-2-active"
import { createRequiredField } from "@/lib/validations/required"
import { z } from "zod"

enum recoverySteps {
  contacts = "CONTACTS",
  otp = "OTP",
  change = "CHANGE",
  success = "SUCCESS",
  error = "ERROR",
}

type RecoveryStepsKey = recoverySteps

const stepPasswordRecovery = {
  [recoverySteps.contacts]: {
    icon: Circle1Active,
    activeIcon: Circle1Active,
    completedIcon: CircleCompletedSvg,
    status: "active",
  },
  [recoverySteps.change]: {
    icon: Circle2,
    activeIcon: Circle2Active,
    completedIcon: CircleCompletedSvg,
    status: "inactive",
  },
}

const otpRefreshed = "otpRefreshed"
const passwordRecoveryStatus = "recPwdStatus"
const recoveryPasswordStep = "recPwdStep"
const recoveryPasswordParam = "recuperaPassword"

const cleanupParams = [
  recoveryPasswordStep,
  otpRefreshed,
  recoveryPasswordParam,
  passwordRecoveryStatus,
]

const BaseContactsFormSchema = z.object({
  mode: z.string(),
  username: createRequiredField()
    .min(6, "Errors.usernameMinLength")
    .max(20, "Errors.usernameMaxLength")
    .refine((value) => !/[^\w.-]/.test(value), "Errors.invalidUsernameValue"),
})

export {
  BaseContactsFormSchema,
  cleanupParams,
  otpRefreshed,
  passwordRecoveryStatus,
  recoveryPasswordParam,
  recoveryPasswordStep,
  recoverySteps,
  stepPasswordRecovery,
}
export type { RecoveryStepsKey }
